import Action from "../actions";

export function setUploadResourceReducer(state =
                                             {
                                                 message: '',
                                                 name: '',
                                                 ext: '',
                                                 targetAction: ''
                                             }
    , action) {

    if (action.type === Action.SET_UPLOAD_RESOURCE) {
        return action.uploadData;
    }
    return state;
}
